export async function settledMutationCounts<T>(
  items: readonly T[],
  run: (item: T) => Promise<unknown>,
): Promise<{ applied: number; failed: number }> {
  const results = await Promise.allSettled(items.map(run));
  return {
    applied: results.filter((r) => r.status === 'fulfilled').length,
    failed: results.filter((r) => r.status === 'rejected').length,
  };
}
